import { type BadgeRewardType } from 'types/api'

// Define which badge reward types have access to which controls
// Required controls should always display
export const badgeRewardControls = {
  Schedule: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'Referral_Count',
      'UniqueLocationVisits',
    ].includes(type),
  StartDateTime: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'PatronProfile_Anniversary',
      'PatronProfile_Birthday',
      'Referral_Count',
      'UniqueLocationVisits',
    ].includes(type),
  EndDateTime: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'PatronProfile_Anniversary',
      'PatronProfile_Birthday',
      'Referral_Count',
      'UniqueLocationVisits',
    ].includes(type),
  Renewable: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'Referral_Count',
      'PatronProfile_Birthday',
    ].includes(type),
  DependentOnBadge: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'PatronProfile_Anniversary',
      'PatronProfile_Birthday',
      'Referral_Count',
    ].includes(type),
  JJPointsToAward: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'PatronProfile_Anniversary',
      'Referral_Count',
      'PatronProfile_Address',
      'PatronProfile_Birthday',
    ].includes(type),
  LocationPointsToAward: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'UniqueLocationVisits',
    ].includes(type),
  LocationSweepstakeEntriesToAward: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'UniqueLocationVisits',
    ].includes(type),
  Count: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'PatronProfile_Anniversary',
      'Referral_Count',
      'UniqueLocationVisits',
    ].includes(type),
  RewardsProgramId: (type: BadgeRewardType) =>
    [
      'CheckIn',
      'CheckInStreak',
      'LocationCheckIn',
      'LocationCheckInStreak',
      'LocationUniqueCheckIn',
      'UniqueLocationVisits',
    ].includes(type),
  LimitCheckins: (type: BadgeRewardType) =>
    ['CheckIn', 'LocationCheckIn'].includes(type),
}

// Check if a badge reward type has access to a specific control
export const badgeRewardTypeHasAccessToControl = (
  type: BadgeRewardType,
  control: keyof typeof badgeRewardControls
) => badgeRewardControls[control]?.(type) ?? false

// Get the display name for a badge reward type
export const getBadgeRewardTypeName = (type: BadgeRewardType) => {
  switch (type) {
    case 'CheckIn':
      return 'Check-In'
    case 'CheckInStreak':
      return 'Check-In Streak'
    case 'LocationCheckIn':
      return 'Location Check-In'
    case 'LocationCheckInStreak':
      return 'Location Check-In Streak'
    case 'LocationUniqueCheckIn':
      return 'Location Unique Check-In'
    case 'PatronProfile_Anniversary':
      return 'Patron Profile - Anniversary'
    case 'Referral_Count':
      return 'Referral - Count'
    case 'PatronProfile_Address':
      return 'Patron Profile - Address'
    case 'PatronProfile_Birthday':
      return 'Patron Profile - Birthday'
    case 'UniqueLocationVisits':
      return 'Unique Location Visits'
    default:
      return ''
  }
}
